import React, { useState, useEffect, useRef } from 'react';

import Trash from '../../../../../assets/images/trash.png';
import Shipupload from "../../../../../assets/images/ship_upload.png";
import Docmnt from '../../../../../assets/images/google-docs.png';
import Export from "../../../../../assets/images/export.svg";
import Edit from "../../../../../assets/images/edit.png";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tab, Tabs, Modal, Row, Col, Button, Form, Accordion, Table, Dropdown } from 'react-bootstrap';
import { faArrowLeft, faCircleXmark, faPencilAlt, faPaperclip, faFileArrowDown, faFileLines, faEllipsisVertical, faDownload, faPaperPlane, faXmark, faStar } from '@fortawesome/free-solid-svg-icons';
import { Step, StepLabel, Stepper } from '@mui/material';
import Select from 'react-select'
import { toast } from 'react-toastify';
import { withoutRFSToken, withRFSToken } from '../../../../../Services/axios.js';
import { AWBGRIDDETAILS, DOWNLOADFILES, TRUCKAWBDETAILS, } from '../../../../../Utils/conts.js';
import { saveAs } from "file-saver";
import Uploadw from '../../../../../assets/images/upload-w.png';
import Radown from "../../../../../assets/images/radown.png";
import Uploadn from '../../../../../assets/images/upload-n.png';

const Attachments = ({ fData, onLoad }) => {
  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({ all_stations: [], origin_notify_status: 1, destination_notify_status: 1 });

  const [rfiles, setRfiles] = useState([]);
  const [sendData, setSendData] = useState({});
  // IMAGE UPLOAD START
  const [showModalUpload, setShowModalUpload] = useState(false);

  const [files, setFiles] = useState([]);
  const [mailFiles, setMailFiles] = useState([]);

  const fileInputRef = useRef(null);
  const msgfileInputRef = useRef(null);
  const [base64Files, setBase64Files] = useState([]);
  const fileInputRefs = useRef({});
  const [activeTab, setActiveTab] = useState('All');
  const [confModal, setConfModal] = useState(false);
  const [uploadTarget, setUploadTarget] = useState('');
  const [typeModal, setTypeModal] = useState(false);
  const [modalSection, setModalSection] = useState('');
  const [typeData, setTypeData] = useState('');
  const [modalData, setModalData] = useState({});

  const detailsData = JSON.parse(localStorage.getItem('TODetails'))

  useEffect(() => {
    if (isMounted.current) return;
    // const detailsData = JSON.parse(localStorage.getItem('OVDetails'))
    // if (detailsData.sec === 'S') {
    //   loadDetails(AWBGRIDDETAILS, detailsData.ULD.awb_id)
    // } else {
    //   loadDetails(TRUCKAWBDETAILS, detailsData.ULD.awb_id)
    //   // setSelectedRowData(detailsData.Left)
    // }
    if (detailsData?.ULD) {
      // setFormData(detailsData?.ULD);
    }
    setFormData()
    isMounted.current = true;

  }, []);

  useEffect(() => {
    if (fData) {
      setFormData(fData);
    }
  }, [fData]);

  const loadDetails = async (endPoint, awbill) => {
    try {
      const res = await withRFSToken.post(endPoint, { awb_id: awbill })
        .then(function (res) {
          const innerData = res.data.response_data;
          setFormData(innerData);
          setIsLoading(false)
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  function extractPath(url) {
    try {
      let urlObject = new URL(url);
      let path = urlObject.pathname.substring(1);
      return path;
    } catch (error) {
      console.error("Invalid URL:", error);
      return null;
    }
  }
  const handleDownload = async (imageUrl, imageName) => {
    const path = extractPath(imageUrl);
    console.log('path', path);

    const res = await withRFSToken
      .post("get-file-blob", {
        file_path: imageUrl,
      })
      .then((response) => {
        const pdfData = atob(response.data.response_data.file_base64);
        const byteNumbers = new Array(pdfData.length);
        for (let i = 0; i < pdfData.length; i++) {
          byteNumbers[i] = pdfData.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], {
          type: response.data.response_data.mime_type,
        });
        saveAs(blob, imageName);
      })
      .catch((error) => {
        console.error("Error during the file download:", error);
        alert("Could not download the file");
      });
  };

  const handleTabChange = async (tab) => {
    setActiveTab(tab);
  }

  const handleOpenModal = (pos, data) => {
    setModalData(data);
    setTypeModal(true);
    setModalSection(pos);
    setTypeData(data.category[0])
  }

  const modalChange = (e) => {
    setTypeData(e.target.value);
  }

  const closeConfirm = () => {
    // setModalData();
    setConfModal(false);
    // setModalSection();
    // setTypeData(data.category[0])
  }

  const modalUpdate = async () => {
    let endPoint = '';
    let payload = {};
    if (modalSection == 'S') {
      if (typeData !== null) {
        endPoint = 'update-attachment-category';
        payload = { attachment_id: modalData.id, category: [typeData] }
      } else {
        toast.error('Please change the type first')
      }
    } else if (modalSection == 'D') {
      endPoint = 'attachment-delete';
      payload = { attachment_id: modalData.id, attachment_type: 'O' }
    }
    setIsLoading(true);
    try {
      const res = await withRFSToken.post(endPoint, payload);
      if (res.data.response_code === 200) {
        onLoad()
        toast.success(res.data.response_msg)
        setTypeModal(false);
        setIsLoading(false);
      } else {
        toast.error(res.data.response_msg)
      }
    } catch (error) {
      console.error('Error saving shipment record:', error);
    }

    // if (modalSection == 'S') {
    //   if (typeData !== null) {
    //     setIsLoading(true);
    //     try {
    //       const res = await withRFSToken.post('update-attachment-category', { attachment_id: modalData.id, category: [typeData] });
    //       if (res.data.response_code === 200) {
    //         // setFormData(res.data.response_data);
    //         loadDetails(formData.service_recovery_id);
    //         toast.success(res.data.response_msg)
    //         setTypeModal(false);
    //       } else {
    //         toast.error(res.data.response_msg)
    //       }
    //     } catch (error) {
    //       console.error('Error saving shipment record:', error);
    //     }
    //   } else {
    //     toast.error('Please change the type first')
    //   }
    // } else if (modalSection == 'D') {
    //   setIsLoading(true)
    //   try {
    //     const res = await withRFSToken.post('attachment-delete', { attachment_id: modalData.id, attachment_type: 'O' });
    //     if (res.data.response_code === 200) {
    //       // setFormData(res.data.response_data);
    //       loadDetails(formData.service_recovery_id);
    //       toast.success(res.data.response_msg)
    //       setTypeModal(false);
    //     } else {
    //       toast.error(res.data.response_msg)
    //     }
    //   } catch (error) {
    //     console.error('Error saving shipment record:', error);
    //   }
    // }
  }

  const handleConfirmation = async () => {

  }

  const [selectedKeys, setSelectedKeys] = useState([]);

  const handleImageSelect = (key, data) => {

    // if (formData.files) {
    const extension = data?.file_name?.split('.').pop().toLowerCase();
    if (["jpeg", "jpg", "png", "webp"].includes(extension)) {

      setFiles((prevFiles) =>
        prevFiles.map((file, index) =>
          index === key
            ? { ...file, primary: file.primary === 1 ? 0 : 1 } // Toggle primary between 1 and 0
            : file // Leave other files unchanged
        )
      );
      setSelectedKeys((prevSelected) =>
        prevSelected.includes(key)
          ? prevSelected.filter((selectedKey) => selectedKey !== key)
          : [...prevSelected, key]
      );
    }
  };

  const imageModalUpload = () => {
    setShowModalUpload(true);
  }
  const closeModalUpload = () => {
    setShowModalUpload(false);
    setFiles([])
    setBase64Files([])
  }
  const handleDrop = (e) => {
    e.preventDefault();
    console.log('E', e);

    const droppedFiles = Array.from(e.dataTransfer.files);
    const selectedFiles = Array.from(e.dataTransfer.files);
    const filesWithBase64 = [];
    let filesProcessed = 0;

    // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
    const existingBase64Files = formData?.base64Files || [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        filesWithBase64.push({ file, base64: reader.result, file_name: file.name });
        filesProcessed += 1;
        if (filesProcessed === selectedFiles.length) {
          const newFiles = filesWithBase64.map((obj) => obj.file);
          // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));

          const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));

          const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

          // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
          setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          setBase64Files(mergedBase64Files);
          setSendData((prevFormData) => {
            // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
            const newFormData = { ...prevFormData, attachments: mergedBase64Files };

            return newFormData;
          });
        }
      };
      reader.readAsDataURL(file);
    });
    // setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    // getBase64(droppedFiles[0]);
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDeleteFile = (index, pos) => {
    setFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    setMailFiles((prevFiles) => {
      const newFiles = [...prevFiles];
      newFiles.splice(index, 1);
      return newFiles;
    });
    if (pos == 'R') {
      setRfiles((prevFiles) => {
        const newFiles = [...prevFiles];
        newFiles.splice(index, 1);
        return newFiles;
      });
    }
    // base64Files.splice(index, 1);
    setBase64Files((prevBase64Files) => {
      const newBase64Files = [...prevBase64Files];
      newBase64Files.splice(index, 1);
      if (pos == 'R') {

        setSendData((prevFormData) => {
          // const newFiles = [...prevFormData.files];
          const newFiles = Array.isArray(prevFormData.files) ? [...prevFormData.files] : [];
          newFiles.splice(index, 1);
          return { ...prevFormData, files: newFiles };
        });
      }
      // Update local storage


      return newBase64Files;
    });
  };

  const handleBrowseFiles = (e, nam) => {
    e.preventDefault();
    // console.log('fileInputRef.current', nam);
    if (nam) {
      if (fileInputRefs.current[nam]) {
        fileInputRefs.current[nam].click();
      }
    } else { fileInputRef.current.click(); }
  };
  const handleBrowseFile = (e, nam) => {
    e.preventDefault();
    msgfileInputRef.current.click();
  };


  function getBase64(file) {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }


  const handleFileChange = (e, pos, chk) => {

    const selectedFiles = Array.from(e.target.files);
    const filesWithBase64 = [];
    let filesProcessed = 0;

    // const existingData = JSON.parse(localStorage.getItem(keyType)) || {};
    const existingBase64Files = formData?.base64Files || [];

    selectedFiles.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = async () => {
        if (file.size > 26214400) {
          toast.error(`${file.name} is too large. Maximum file size is 25MB.`);
          return;
        }
        filesWithBase64.push({ file, base64: reader.result, file_name: file.name, type: file.type });
        filesProcessed += 1;
        if (filesProcessed === selectedFiles.length) {
          // if (pos === 'C') { // pos === 'A' || 
          //     // const newFiles = filesWithBase64.map((obj) => obj.file);
          //     // const newBase64Files = filesWithBase64.map((obj) => obj.base64);
          //     const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
          //     const mergedBase64Files = [...existingBase64Files, ...newBase64Files];
          //     // setFiles(newFiles);


          //     const payload = {
          //         shipmen_id: formData.id,
          //         shipmen_type: "export",
          //         attachments: mergedBase64Files
          //     }
          //     // console.log('payload', payload);
          //     try {
          //         const res = await withRFSToken.post('shipment/upload-doc', payload);
          //         console.log('API Response:', res.data);
          //         if (res.data.response_code === 200) {
          //             toast.success(res.data.response_msg);
          //             setFormData(res.data.response_data);
          //         } else {
          //             toast.error(res.data.response_msg);
          //         }
          //     } catch (error) {
          //         console.error('Error saving shipment record:', error);
          //     }

          // } else {
          const newFiles = filesWithBase64.map((obj) => obj.file);
          let newBase64Files;
          if (pos === 'C') {
            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }));
          } else {
            newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
          }
          console.log('newBase64Files', newBase64Files);

          // const newBase64Files = filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }));
          const mergedBase64Files = [...existingBase64Files, ...newBase64Files];

          // setFiles((prevFiles) => [...prevFiles, ...newFiles]);
          if (pos === 'C') {
            setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, category: [chk] }))]);
          } else {
            setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
          }
          setBase64Files(mergedBase64Files);
          // if (pos == 'R') {
          //     setRfiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name, type: obj.type }))]);
          //     setSendData((prevFormData) => {
          //         // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
          //         const newFormData = { ...prevFormData, attachments: mergedBase64Files };

          //         return newFormData;
          //     });
          // } else if (pos == 'M') {
          //     // const newFiles = filesWithBase64.map((obj) => obj.file);
          //     setMailFiles((prevFiles) => [...prevFiles, ...newFiles]);
          //     // setMailForm((prevFormData) => {
          //     //     // const newFormData = { ...prevFormData, files: newFiles, base64Files: mergedBase64Files };
          //     //     const newFormData = { ...prevFormData, attachments: mergedBase64Files };

          //     //     return newFormData;
          //     // });
          // }

          // }
        }
      };
      reader.readAsDataURL(file);
    });


  };
  const imageUpload = async () => {
    // setGridSelect(prevGridSelect =>
    //     prevGridSelect.map(item => {
    //         if (item.uid === selectedRowId) {
    //             return { ...item, files: files, base64Files: base64Files };
    //         }
    //         return item;
    //     })
    // );
    // setShowModalUpload(false);{selectedRowData.sec === 'D'? 'rfs_awb' : 'awb_monitor'}
    if (!files.length) {
      toast.error('Please select an Image')
      return;
    }
    setIsLoading(true)
    const payload = {
      attachable_id: detailsData.truck_orders_id,
      attachable_type: 'truck_order',
      files: files
    }
    // console.log('payload', payload);
    try {
      const res = await withRFSToken.post('attachment-save', payload);
      console.log('API Response:', res.data);
      if (res.data.response_code === 200) {
        toast.success(res.data.response_msg);
        // loadDetails(formData.service_recovery_id);
        onLoad()
        setShowModalUpload(false);
        setFiles([])
        setBase64Files([]);
      } else {
        toast.error(res.data.response_msg);
      }
      setIsLoading(false)
    } catch (error) {
      console.error('Error saving shipment record:', error);
    }
  };

  const multipleDownload = async () => {

    const attachmed = formData.attachments.map((prevSelectedRows) => (
      { attachment_id: prevSelectedRows.id, attachment_type: prevSelectedRows.attachment_type }
    ));
    const payload = {
      // service_recovery_id: propdata.service_recovery_id,
      attachments: attachmed
    }

    const res = await withRFSToken.post(DOWNLOADFILES, payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        },
        responseType: 'blob', // important for handling binary file download like Excel
      }
    ).then(response => {
      const blob = new Blob([response.data], { type: response.headers['content-type'] });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'attachments.zip';
      document.body.appendChild(a);
      a.click();
      a.remove();
      toast.success("Downloaded Successfully");
    });
    // const res = await withRFSToken.post(DOWNLOADFILES, payload) // { uld_number: attachable_type == 'booking_schedule_date' || attachable_type == 'booking_schedule' || attachable_type == 'missing_uld' ? attachment_no : attachable_id, attachments: selectedRows, }
    //   .then(function (res) {
    //     if (res.data.response_code == 200) {
    //       const downloadUrl = res.data.response_data;
    //       const a = document.createElement("a");
    //       a.href = downloadUrl;
    //       a.download = "download.zip"; // You can set a default filename here
    //       document.body.appendChild(a);
    //       a.click();
    //       document.body.removeChild(a);
    //       toast.success("Downloaded Successfully");
    //     } else {
    //       toast.error(res.data.response_msg);
    //     }
    //   });
  };
  const attachmentLabels = {
    MAWB: "MAWB",
    HAWB: "HAWB",
    Invoice: "Invoice",
    PackingList: "Packing List",
    Other: "Other"
  };

  return (
    <>
      {isLoading &&
        <div className='mvt loader-container' style={{ top: '0', height: '1084px' }}><span className='mvt loader' style={{ left: 'calc(50% - 17px)', top: '40vh' }}></span></div>
      }
      {console.log('formData', formData)}
      <Row>
        <Col sm={12}>
          <div className='flbg h-100'>
            <div className='all_file mb-3'>
              <div><h4>All files</h4></div>
              <div className='d-flex align-items-center'>
                <div className="gallery_download">
                  <Button onClick={multipleDownload} variant="link" disabled={formData?.attachments?.length == 0}>
                    <img src={Export} /> <span>All Download</span>
                  </Button>
                </div>

                <div>
                  <Button variant="primary" onClick={imageModalUpload}> <img src={Uploadw} /> Upload file</Button>
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={(e) => handleFileChange(e, 'A')}
                    multiple
                  />
                </div>

              </div>

            </div>

            <Tabs
              defaultActiveKey={activeTab}
              onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''}
              id="station-tabs"
              className="attach_tab"
              style={{ width: '52%' }}
            >
              <Tab eventKey="All" title={<span>View All </span>} className='moveto'>
                <Table className='record_table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                       <th>Download Options</th>
                      <th>File Name</th>
                      {/* <th>Documents</th>
                      <th>Source</th> */}
                      <th>Uploaded by</th>
                      <th>Uploaded On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.attachments?.map((data, index) => {
                      const fileName = data.file_name;
                      const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                      const extension = fileName?.split(".").pop();
                      console.log('data', data);

                      return (
                        <tr>
                          <td>
                            <Form.Check // prettier-ignore
                              type="checkbox"
                              id="checkbox"
                            // checked={selectedRows.some(
                            //     (row) => row.attachment_id === file.id
                            // )}
                            // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                            />
                          </td>
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                          </td>
                          <td><div className='file_attch'>
                            {["jpeg", "jpg", "png", "webp"].includes(data.file_name?.split(".")[data.file_name?.split(".").length - 1]
                            ) ? (
                              <>
                                <div className='file_icon'>
                                  <img
                                    src={data.file_path}
                                    alt="Preview"
                                    style={{
                                      maxWidth: "22px",
                                      maxHeight: "22px",
                                      marginRight: "10px",
                                    }}
                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  // onClick={() => handleFileClick(data.file_path)}
                                  />
                                </div>
                                <div className='file_text'>
                                  <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                  <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                </div>
                                {/* <span> */}
                                {/*data.file_name*/}
                                {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                {/* </span> */}

                              </>
                            ) : (
                              <>
                                <div className='file_icon'>
                                  <FontAwesomeIcon icon={faFileLines} />
                                </div>
                                <div className='file_text'>
                                  <p>{data.file_name}</p>
                                  <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                </div>
                                {/* <span className="d-flex rafilename">
                                                        <img src={Docmnt} className="fileimg" />
                                                        <span>{data.file_name}</span>
                                                    </span> */}
                              </>
                            )}
                          </div>
                            {/* <div className='file_attch'>
                                                <div className='file_icon'>
                                                    <FontAwesomeIcon icon={faFileLines} />
                                                </div>
                                                <div className='file_text'>
                                                    <p>{data.file_name}</p>
                                                    <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                </div>
                                            </div> */}
                          </td>
                          <td><p>{data.category.length > 0 ? data.category : ''}</p></td>
                          <td><p>{data.source_type}</p></td>
                          <td>
                            <p>{data.uploaded_by_org_name}</p>
                            <span>{data.uploaded_by_org_email}</span>
                          </td>
                          <td>
                            <span>{data.last_modified}</span>
                          </td>
                          <td>
                            <div className='d-flex justify-content-end align-items-center start_icon'>
                              {/* {data.source_type !== 'Email' && <img src={Edit} onClick={() => handleOpenModal('S', data)} />} */}
                              {data.primary == 1 && <FontAwesomeIcon icon={faStar} />}
                              {data.source_type == 'Email' ?
                                <><img src={Edit} style={{ opacity: 0.5 }} /> <img src={Trash} style={{ opacity: 0.5 }} /></>
                                :
                                <>
                                  <img src={Edit} onClick={() => handleOpenModal('S', data)} />
                                  <img src={Trash} onClick={() => handleOpenModal('D', data)} />
                                </>
                              }
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="Documents" title={<span>Documents </span>} className='moveto'>
                <Table className='record_table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>Download Options</th>
                      <th>File Name</th>
                      {/* <th>Documents</th>
                      <th>Source</th> */}
                      <th>Uploaded by</th>
                      <th>Uploaded On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.attachments?.filter(data => ['document', "doc", "docx", "txt"].includes(data.file_ext.toLowerCase()))
                      .map((data, index) => (
                        <tr>
                          <td>
                            <Form.Check // prettier-ignore
                              type="checkbox"
                              id="checkbox"
                            // checked={selectedRows.some(
                            //     (row) => row.attachment_id === file.id
                            // )}
                            // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                            />
                          </td>
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                          </td>
                          <td>
                            <div className='file_attch'>
                              <div className='file_icon'>
                                <FontAwesomeIcon icon={faFileLines} />
                              </div>
                              <div className='file_text'>
                                <p>{data.file_name}</p>
                                <span>{data.file_size}</span> <span>{data.file_ext}</span>
                              </div>
                            </div>
                          </td>
                          <td><p>{data.category.length > 0 ? data.category : ''}</p></td>
                          <td><p>{data.source_type}</p></td>
                          <td>
                            <p>{data.uploaded_by_org_name}</p>
                            <span>{data.uploaded_by_org_email}</span>
                          </td>
                          <td>
                            <span>{data.last_modified}</span>
                          </td>
                          <td>
                            <div className='d-flex justify-content-end align-items-center start_icon'>
                              {/* {data.primary == 1 && <FontAwesomeIcon icon={faStar} />} */}
                              {data.source_type == 'Email' ?
                                <><img src={Edit} style={{ opacity: 0.5 }} /> <img src={Trash} style={{ opacity: 0.5 }} /></>
                                :
                                <>
                                  <img src={Edit} onClick={() => handleOpenModal('S', data)} />
                                  <img src={Trash} onClick={() => handleOpenModal('D', data)} />
                                </>
                              }
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="Spreadsheets" title={<span>Spreadsheets </span>} className='moveto'>
                <Table className='record_table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>File Name</th>
                      <th>Document Type</th>
                      <th>Source</th>
                      <th>Uploaded by</th>
                      <th>Added On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.attachments?.filter(data => ["xls", "xlsx", "csv"].includes(data.file_ext.toLowerCase()))
                      .map((data, index) => (
                        <tr>
                          <td>
                            <Form.Check // prettier-ignore
                              type="checkbox"
                              id="checkbox"
                            // checked={selectedRows.some(
                            //     (row) => row.attachment_id === file.id
                            // )}
                            // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                            />
                          </td>
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                          </td>
                          <td>
                            <div className='file_attch'>
                              <div className='file_icon'>
                                <FontAwesomeIcon icon={faFileLines} />
                              </div>
                              <div className='file_text'>
                                <p>{data.file_name}</p>
                                <span>{data.file_size}</span> <span>{data.file_ext}</span>
                              </div>
                            </div>
                          </td>
                          <td><p>{data.category.length > 0 ? data.category : ''}</p></td>
                          <td><p>{data.source_type}</p></td>
                          <td>
                            <p>{data.uploaded_by_org_name}</p>
                            <span>{data.uploaded_by_org_email}</span>
                          </td>
                          <td>
                            <span>{data.last_modified}</span>
                          </td>
                          <td>
                            <div className='d-flex justify-content-end align-items-center start_icon'>
                              {/* {data.primary == 1 && <FontAwesomeIcon icon={faStar} />} */}
                              {data.source_type == 'Email' ?
                                <><img src={Edit} style={{ opacity: 0.5 }} /> <img src={Trash} style={{ opacity: 0.5 }} /></>
                                :
                                <>
                                  <img src={Edit} onClick={() => handleOpenModal('S', data)} />
                                  <img src={Trash} onClick={() => handleOpenModal('D', data)} />
                                </>
                              }
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="pdfs" title={<span>PDF's </span>} className='moveto'>
                <Table className='record_table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>File Name</th>
                      <th>Document Type</th>
                      <th>Source</th>
                      <th>Uploaded by</th>
                      <th>Added On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.attachments?.filter(data => ["pdf"].includes(data.file_ext.toLowerCase()))
                      .map((data, index) => (
                        <tr>
                          <td>
                            <Form.Check // prettier-ignore
                              type="checkbox"
                              id="checkbox"
                            // checked={selectedRows.some(
                            //     (row) => row.attachment_id === file.id
                            // )}
                            // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                            />
                          </td>
                          <td className="delimg">
                            <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                          </td>
                          <td>
                            <div className='file_attch'>
                              <div className='file_icon'>
                                <FontAwesomeIcon icon={faFileLines} />
                              </div>
                              <div className='file_text'>
                                <p>{data.file_name}</p>
                                <span>{data.file_size}</span> <span>{data.file_ext}</span>
                              </div>
                            </div>
                          </td>
                          <td><p>{data.category.length > 0 ? data.category : ''}</p></td>
                          <td><p>{data.source_type}</p></td>
                          <td>
                            <p>{data.org_name}</p>
                            <span>{data.uploaded_by_org_email}</span>
                          </td>
                          <td>
                            <span>{data.last_modified}</span>
                          </td>
                          <td>
                            <div className='d-flex justify-content-end align-items-center start_icon'>
                              {/* {data.primary == 1 && <FontAwesomeIcon icon={faStar} />} */}
                              {data.source_type == 'Email' ?
                                <><img src={Edit} style={{ opacity: 0.5 }} /> <img src={Trash} style={{ opacity: 0.5 }} /></>
                                :
                                <>
                                  <img src={Edit} onClick={() => handleOpenModal('S', data)} />
                                  <img src={Trash} onClick={() => handleOpenModal('D', data)} />
                                </>
                              }
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Tab>
              <Tab eventKey="ImageDs" title={<span>Images </span>} className='moveto'>
                <Table className='record_table'>
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                      <th>File Name</th>
                      <th>Document Type</th>
                      <th>Source</th>
                      <th>Uploaded by</th>
                      <th>Added On</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData?.attachments?.filter(data => ["jpg", "jpeg", "png", "bmp"].includes(data.file_ext.toLowerCase()))
                      .map((data, index) => {
                        const fileName = data.file_name;
                        const baseName = fileName?.substring(0, fileName.lastIndexOf("."));
                        const extension = fileName?.split(".").pop();

                        return (
                          <tr>
                            <td>
                              <Form.Check // prettier-ignore
                                type="checkbox"
                                id="checkbox"
                              // checked={selectedRows.some(
                              //     (row) => row.attachment_id === file.id
                              // )}
                              // onChange={(e) => handleCheckboxChange(file, e.target.checked)}
                              />
                            </td>
                            <td className="delimg">
                              <img src={Radown} onClick={() => handleDownload(data.file_path, data.file_name)} />
                            </td>
                            <td>
                              <div className='file_attch'>
                                <div className='file_icon'>
                                  <img
                                    src={data.file_path}
                                    alt="Preview"
                                    style={{
                                      maxWidth: "22px",
                                      maxHeight: "22px",
                                      marginRight: "10px",
                                    }}
                                  // onClick={() => handleFileClick(URL.createObjectURL(file))}
                                  // onClick={() => handleFileClick(data.file_path)}
                                  />
                                </div>
                                <div className='file_text'>
                                  <p>{data.file_name}</p>
                                  <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                </div>
                                {/* <span> */}
                                {/*data.file_name*/}
                                {/* {baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 40)}... .${extension}`} */}
                                {/* </span> */}
                              </div>
                              {/* <div className='file_attch'>
                                                    <div className='file_icon'>
                                                        <FontAwesomeIcon icon={faFileLines} />
                                                    </div>
                                                    <div className='file_text'>
                                                        <p>{baseName?.length <= 7 ? fileName : `${baseName?.substring(0, 20)}... .${extension}`}</p>
                                                        <span>{data.file_size}</span> <span>{data.file_ext}</span>
                                                    </div>
                                                </div> */}
                            </td>
                            <td><p>{data.category.length > 0 ? data.category : ''}</p></td>
                            <td><p>{data.source_type}</p></td>
                            <td>
                              <p>{data.uploaded_by_org_name}</p>
                              <span>{data.uploaded_by_org_email}</span>
                            </td>
                            <td>
                              <span>{data.last_modified}</span>
                            </td>
                            <td>
                              <div className='d-flex justify-content-end align-items-center start_icon'>
                                {data.primary == 1 && <FontAwesomeIcon icon={faStar} />}
                                {data.source_type == 'Email' ?
                                  <><img src={Edit} style={{ opacity: 0.5 }} /> <img src={Trash} style={{ opacity: 0.5 }} /></>
                                  :
                                  <>
                                    <img src={Edit} onClick={() => handleOpenModal('S', data)} />
                                    <img src={Trash} onClick={() => handleOpenModal('D', data)} />
                                  </>
                                }
                              </div>
                            </td>
                          </tr>
                        )
                      })}
                  </tbody>
                </Table>
              </Tab>
            </Tabs>
          </div >
        </Col>
      </Row>
      <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
        <Modal.Body>
          <h3>The Attachment will be deleted. </h3>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeConfirm}> No</Button>
            <Button variant="primary" onClick={handleConfirmation}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={showModalUpload} onHide={closeModalUpload} className='addfrom change_type' centered>
        <Modal.Header closeButton>
          <div className='modal-title h4'>Upload Attachmentsssssss</div>
          <p className='text-start'>Drag and drop or browse to upload your attachments.</p>
        </Modal.Header>
        <Modal.Body>
          <div className='type_work'>

            <div className='ra_condition'>
              <div
                className='dropfile'
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                <img src={Shipupload} alt="upload" />
                <h3>Drag and drop files here</h3>
                <p>Or</p>
                <button className='btn btn-primary drpbtn' onClick={uploadTarget ? (e) => handleBrowseFiles(e, uploadTarget) : handleBrowseFiles}>Browse Files</button>
                <span>Maximum file size 25 MB</span>
                <input
                  type="file"
                  // ref={fileInputRef.current}
                  ref={(el) => {
                    if (uploadTarget) {
                      fileInputRefs.current[uploadTarget] = el;
                    }
                  }}
                  style={{ display: 'none' }}
                  // onChange={handleFileChange}
                  onChange={uploadTarget ? (e) => handleFileChange(e, 'C', uploadTarget) : (e) => handleFileChange(e, 'A')}
                  multiple
                />
              </div>
              <div className='upimg_recover'>
                <span className='frprimary'>User can select image for primary image </span>
                <div className='d-flex dv_wrap'>
                  {console.log('selectedKeys', selectedKeys)}
                  {files.map((file, index) => (
                    <div key={index} className={`img-thumbnail ${selectedKeys.includes(index) ? 'primaryimg' : ''}`} onClick={() => handleImageSelect(index, file)}>
                      {file.base64.includes('image') ? (
                        <>
                          <img
                            src={file.base64}
                            alt="Preview"
                            style={{ maxWidth: '30px', maxHeight: '30px', marginRight: '10px' }}
                          />
                          <span>{file.file_name}</span>
                        </>
                      ) : (
                        <>  <img src={Docmnt} className='fileimg' /> <span> {file.file_name}</span> </>
                      )}
                      <button className='dltbtn' type="button" onClick={() => handleDeleteFile(index)}> <FontAwesomeIcon icon={faCircleXmark} color='#656565' /></button>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="primary" onClick={imageUpload}>
              Upload
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={typeModal} onHide={() => { setTypeModal(false); }} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          <h3>{modalSection === 'S' ? 'Attachment Type' : 'Remove Attachment'}</h3>
          <p>{modalSection === 'S' ? 'Update this attachment type' : 'Are you sure you want delete this attachment?'}</p>
          {modalSection === 'S' &&
            <Form.Group className="me-2">
              <Form.Select aria-label="Select" onChange={(e) => modalChange(e)} value={typeData || "0"}>
                <option value="0">Select</option>
                <option value="MAWB">MAWB</option>
                <option value="HAWB">HAWB</option>
                <option value="Invoice">Invoice</option>
                <option value="IrregularityReport">Irregularity Report</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            {modalSection === 'S' ?
              <Button variant="primary" onClick={modalUpdate}>
                Update
              </Button>
              :
              <>
                <Button variant="secondary" onClick={() => setTypeModal(false)}>
                  No
                </Button>
                <Button variant="primary" onClick={modalUpdate}>
                  Yes
                </Button>
              </>
            }
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default Attachments